import { createAction, props } from "@ngrx/store";
export const setGenericDocInvListing_State = createAction(
  "[Column 1 View Model] Set Generic Doc Inv Listing State",
  props<{ genericDocInvListingState: any }>()
);